import { Expose, Type } from 'class-transformer';
import { AvlDevicePosition } from '@features/live-tracking/models/avl-device-position';
import { TruckHasShipment } from '../../fleets/models/truck-has-shipment.model';
import { Tracking } from '@features/live-tracking/models/tracking-driver';
import { AvlShipmentStop } from '@features/live-tracking/models/avl-shipment-stop.model';
import { Model } from '@shared-features/models/model';
import { AvlOverSpeed } from '@features/live-tracking/models/avl-over-speed.model';
import { G2gLocation } from '@features/live-tracking/models/g2g-location.model';

export class AvlReplay extends Model {
  @Type(() => Tracking)
  @Expose() current: Tracking;

  @Type(() => TruckHasShipment)
  @Expose() truck: TruckHasShipment;

  @Type(() => AvlDevicePosition)
  @Expose() ignitions: (AvlDevicePosition&{ignition?: boolean})[];

  @Type(() => AvlDevicePosition)
  @Expose() brakes: AvlDevicePosition[];

  @Expose() stopDurations: string;
  @Expose() stopsCount: number;

  @Type(() => AvlShipmentStop)
  @Expose() stops: AvlShipmentStop[];

  @Expose() overSpeedCount: number;

  @Type(() => AvlOverSpeed)
  @Expose() overSpeed: AvlOverSpeed[];

  @Type(() => G2gLocation)
  @Expose() gateToGate: G2gLocation[];

  @Expose() showIgnitions: boolean;
  @Expose() showBrakes: boolean;
  @Expose() showStops: boolean;
  @Expose() showOverSpeed: boolean;
  @Expose() showGateToGate: boolean;
}
